import React, { Fragment } from 'react';

import { Transition } from '@headlessui/react';

type AnimatedTransitionProps = {
  show: boolean;
  children: React.ReactNode;
  asFragment?: boolean;
  className?: string;
  appear?: boolean;
  ['data-testid']?: string;
};

const AnimatedTransition = ({
  show,
  children,
  asFragment = false,
  appear = false,
  className,
  ...rest
}: AnimatedTransitionProps) => {
  const content = (
    <Transition
      show={show}
      enter="transition-all ease-in-out duration-500"
      enterFrom="opacity-0 max-h-0"
      enterTo="opacity-100 max-h-content"
      leave="transition-all ease-in-out duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0 max-h-0"
      as={asFragment ? Fragment : undefined}
      appear={appear}
    >
      {children}
    </Transition>
  );

  return className ? (
    <div className={className} {...rest}>
      {content}
    </div>
  ) : (
    content
  );
};

export default AnimatedTransition;
